var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { getDictionary } from '@synisys/dictionary';
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { isNil } from 'lodash-es';
import { hideMenuProvider } from '../../utilities/picker.tools';
import styles from '../sds-date-picker.lit.scss';
import '../shared/calendar/sds-calendar.lit';
import { pairLessOrEqual } from '../shared/comparators';
import { quarterHoverStateMapper, quarterRangeMapper, yearRangeMapper } from '../shared/mapper-utils';
import { getYear } from '../shared/utils';
import { translate } from '../../utilities/translate';
import { quarterDateToKey, quarterKeyToDate } from './quarter-picker-calculations';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * `sds-quarter-range` is a web component that enables users to select a range of quarters
 * within a year, providing an intuitive interface for defining start and end quarters.
 * This component is particularly useful in applications that require date range filtering,
 * such as financial reporting, project planning, or data analysis.
 *
 * ### Features:
 * - **Quarter Range Selection**: Users can easily select a start and end quarter,
 *   facilitating straightforward definition of a quarter range for data retrieval or analysis.
 * - **Events**: Emits events to inform parent components of changes in the selected quarter range.
 */
let SdsQuarterRange = (() => {
    var _SdsQuarterRange_placeholder_accessor_storage, _SdsQuarterRange_hint_accessor_storage, _SdsQuarterRange_disabled_accessor_storage, _SdsQuarterRange_invalid_accessor_storage, _SdsQuarterRange_errorMessage_accessor_storage, _SdsQuarterRange_currentQuarter_accessor_storage, _SdsQuarterRange_startQuarter_accessor_storage, _SdsQuarterRange_endQuarter_accessor_storage, _SdsQuarterRange__contextMenu_accessor_storage, _SdsQuarterRange__inputDate_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-quarter-range')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let _currentQuarter_decorators;
    let _currentQuarter_initializers = [];
    let _currentQuarter_extraInitializers = [];
    let _startQuarter_decorators;
    let _startQuarter_initializers = [];
    let _startQuarter_extraInitializers = [];
    let _endQuarter_decorators;
    let _endQuarter_initializers = [];
    let _endQuarter_extraInitializers = [];
    let __contextMenu_decorators;
    let __contextMenu_initializers = [];
    let __contextMenu_extraInitializers = [];
    let __inputDate_decorators;
    let __inputDate_initializers = [];
    let __inputDate_extraInitializers = [];
    var SdsQuarterRange = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsQuarterRange_placeholder_accessor_storage.set(this, __runInitializers(this, _placeholder_initializers, 'sds.quarter_picker_range.placeholder'));
            _SdsQuarterRange_hint_accessor_storage.set(this, (__runInitializers(this, _placeholder_extraInitializers), __runInitializers(this, _hint_initializers, '')));
            _SdsQuarterRange_disabled_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsQuarterRange_invalid_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsQuarterRange_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            _SdsQuarterRange_currentQuarter_accessor_storage.set(this, (__runInitializers(this, _errorMessage_extraInitializers), __runInitializers(this, _currentQuarter_initializers, void 0)));
            _SdsQuarterRange_startQuarter_accessor_storage.set(this, (__runInitializers(this, _currentQuarter_extraInitializers), __runInitializers(this, _startQuarter_initializers, void 0)));
            _SdsQuarterRange_endQuarter_accessor_storage.set(this, (__runInitializers(this, _startQuarter_extraInitializers), __runInitializers(this, _endQuarter_initializers, void 0)));
            _SdsQuarterRange__contextMenu_accessor_storage.set(this, (__runInitializers(this, _endQuarter_extraInitializers), __runInitializers(this, __contextMenu_initializers, void 0)));
            _SdsQuarterRange__inputDate_accessor_storage.set(this, (__runInitializers(this, __contextMenu_extraInitializers), __runInitializers(this, __inputDate_initializers, void 0)));
            this._sdsInnerQuarterPicker = __runInitializers(this, __inputDate_extraInitializers);
            this.hideMenu = hideMenuProvider(this);
            this.mouseOutHandler = () => {
                if (this.endQuarter === undefined) {
                    this._sdsInnerQuarterPicker.setQuarterStateMapper(quarterRangeMapper(this.startQuarter, undefined));
                }
            };
            this.handleCleared = () => {
                var _a;
                this._inputDate.focused = Boolean((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened);
                this.updateValue();
                this.updatePageIndex();
            };
            this.handleHover = (event) => {
                if (this.startQuarter !== undefined &&
                    this.endQuarter === undefined &&
                    event.detail.quarter !== undefined) {
                    this._sdsInnerQuarterPicker.setQuarterStateMapper(quarterHoverStateMapper(this.startQuarter, event.detail.quarter));
                }
                else if (event.detail.quarter === undefined) {
                    this.setMappers();
                }
            };
            this.showContextMenu = () => {
                var _a, _b;
                if (!((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened)) {
                    this.resetPage();
                    this._inputDate.focused = true;
                    const trigger = this._inputDate.getInput();
                    (_b = this._contextMenu) === null || _b === void 0 ? void 0 : _b.show(trigger);
                    this.setMappers();
                }
            };
            this.handleQuarterPicked = (event) => {
                this.updateSelectedQuarter([event.detail.year, event.detail.quarter]);
            };
            this.handleYearChanged = (event) => {
                if (isNil(this.startQuarter) || !(isNil(this.startQuarter) || isNil(this.endQuarter))) {
                    this._preselectedStartYear = event.detail.year;
                    this._preselectedEndYear = undefined;
                }
                else {
                    this._preselectedEndYear = event.detail.year;
                }
                this.setMappers();
            };
        }
        /**
         * The placeholder text displayed in the input fields of the quarter range picker.
         * This text serves as a prompt for users, indicating what they should input
         * or select in the quarter range fields. It is useful for providing context
         * and enhancing user experience by guiding users on the expected input format.
         *
         * @attr {string} placeholder - The placeholder text for the quarter range input fields.
         */
        get placeholder() { return __classPrivateFieldGet(this, _SdsQuarterRange_placeholder_accessor_storage, "f"); }
        set placeholder(value) { __classPrivateFieldSet(this, _SdsQuarterRange_placeholder_accessor_storage, value, "f"); }
        /**
         * Hint for this quarter range.
         * @attr
         */
        get hint() { return __classPrivateFieldGet(this, _SdsQuarterRange_hint_accessor_storage, "f"); }
        set hint(value) { __classPrivateFieldSet(this, _SdsQuarterRange_hint_accessor_storage, value, "f"); }
        /**
         * True if this quarter range is disabled.
         * @attr
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsQuarterRange_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsQuarterRange_disabled_accessor_storage, value, "f"); }
        /**
         * True if this quarter range is invalid.
         * @attr
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsQuarterRange_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsQuarterRange_invalid_accessor_storage, value, "f"); }
        /**
         * The error message of this quarter range, in case there is a validation error.
         * @attr
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsQuarterRange_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsQuarterRange_errorMessage_accessor_storage, value, "f"); }
        /**
         * The current quarter being displayed in the picker, formatted as `{year}/{quarter}`.
         * This property reflects the selected quarter within the current context, allowing
         * users to see which quarter they are currently interacting with.
         * It is useful for maintaining context, especially when selecting a range of quarters.
         *
         * @attr {string} current-quarter - The current quarter in the format `{year}/{quarter}`.
         */
        get currentQuarter() { return __classPrivateFieldGet(this, _SdsQuarterRange_currentQuarter_accessor_storage, "f"); }
        set currentQuarter(value) { __classPrivateFieldSet(this, _SdsQuarterRange_currentQuarter_accessor_storage, value, "f"); }
        /**
         * The starting quarter of the range, represented as a string.
         * The value should be formatted according to the {year}/{quarter} structure. This property
         * is useful for defining the beginning of a selected quarter range.
         *
         * The `quarterKeyToDate` converter is used to transform the input string
         * into a usable date format.
         *
         * @attr {string} start-quarter - The starting quarter of the range in the format `{year}/{quarter}`.
         */
        get startQuarter() { return __classPrivateFieldGet(this, _SdsQuarterRange_startQuarter_accessor_storage, "f"); }
        set startQuarter(value) { __classPrivateFieldSet(this, _SdsQuarterRange_startQuarter_accessor_storage, value, "f"); }
        /**
         * The ending quarter of the range, represented as a string.
         * The value should be formatted according to the {year}/{quarter} structure. This property
         * is useful for defining the conclusion of a selected quarter range.
         *
         * The `quarterKeyToDate` converter is used to transform the input string
         * into a usable date format.
         *
         * @attr {string} end-quarter - The ending quarter of the range in the format `{year}/{quarter}`.
         */
        get endQuarter() { return __classPrivateFieldGet(this, _SdsQuarterRange_endQuarter_accessor_storage, "f"); }
        set endQuarter(value) { __classPrivateFieldSet(this, _SdsQuarterRange_endQuarter_accessor_storage, value, "f"); }
        get _contextMenu() { return __classPrivateFieldGet(this, _SdsQuarterRange__contextMenu_accessor_storage, "f"); }
        set _contextMenu(value) { __classPrivateFieldSet(this, _SdsQuarterRange__contextMenu_accessor_storage, value, "f"); }
        get _inputDate() { return __classPrivateFieldGet(this, _SdsQuarterRange__inputDate_accessor_storage, "f"); }
        set _inputDate(value) { __classPrivateFieldSet(this, _SdsQuarterRange__inputDate_accessor_storage, value, "f"); }
        render() {
            return html `
            <sds-input-date
                id="input-date"
                placeholder="${translate(this.placeholder)}"
                readonly
                ?disabled="${this.disabled}"
                hint="${this.hint}"
                error-message="${this.errorMessage}"
                ?invalid="${this.invalid}"
                @click="${this.showContextMenu}"
                @sds.input-date.cleared="${this.handleCleared}"
            ></sds-input-date>
            <sds-context-menu id="context-menu">
                <sds-inner-quarter-picker
                    id="sds-inner-quarter-picker"
                    currentQuarter="${this.currentQuarter}"
                    @mouseout="${this.mouseOutHandler}"
                    @sds.inner-quarter-picker.hovered="${this.handleHover}"
                    @sds.inner-quarter-picker.changed="${this.handleQuarterPicked}"
                    @sds.inner-quarter-picker.year-changed="${this.handleYearChanged}"
                >
                </sds-inner-quarter-picker>
            </sds-context-menu>
        `;
        }
        connectedCallback() {
            super.connectedCallback();
            document.addEventListener('mouseup', this.hideMenu);
        }
        disconnectedCallback() {
            document.removeEventListener('mouseup', this.hideMenu);
            this.hideContextMenu();
            super.disconnectedCallback();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        willUpdate(_changedProperties) {
            if (_changedProperties.has('startQuarter') || _changedProperties.has('endQuarter')) {
                this.setMappers();
            }
            if (_changedProperties.has('endQuarter') && this.endQuarter !== undefined) {
                this.hideContextMenu();
                // this.resetPreselectedYears();
            }
        }
        updated(_changedProperties) {
            if (_changedProperties.has('startQuarter') || _changedProperties.has('endQuarter')) {
                this.updateInput();
            }
        }
        async firstUpdated() {
            this.initCmContentContainer();
            await this.updateComplete;
            this.updatePageIndex();
        }
        setMappers() {
            var _a, _b, _c;
            const startYear = (_a = this._preselectedStartYear) !== null && _a !== void 0 ? _a : getYear(this.startQuarter);
            let endYear;
            if (!isNil(this.endQuarter) && isNil(this._preselectedStartYear)) {
                // case when endQuarter is set by user
                endYear = getYear(this.endQuarter);
            }
            else {
                endYear = this._preselectedEndYear;
            }
            (_b = this._sdsInnerQuarterPicker) === null || _b === void 0 ? void 0 : _b.setYearStateMapper(yearRangeMapper(startYear, endYear));
            (_c = this._sdsInnerQuarterPicker) === null || _c === void 0 ? void 0 : _c.setQuarterStateMapper(quarterRangeMapper(this.startQuarter, this.endQuarter));
        }
        updatePageIndex() {
            var _a, _b;
            if (this.startQuarter) {
                (_a = this._sdsInnerQuarterPicker) === null || _a === void 0 ? void 0 : _a.updatePageIndex(this.startQuarter[0]);
            }
            else if (this.currentQuarter) {
                (_b = this._sdsInnerQuarterPicker) === null || _b === void 0 ? void 0 : _b.updatePageIndex(quarterKeyToDate(this.currentQuarter)[0]);
            }
        }
        initCmContentContainer() {
            var _a;
            const sdsQuarterPicker = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#sds-inner-quarter-picker');
            if (sdsQuarterPicker) {
                this._sdsInnerQuarterPicker = sdsQuarterPicker;
            }
        }
        resetPage() {
            var _a;
            (_a = this._sdsInnerQuarterPicker) === null || _a === void 0 ? void 0 : _a.navigateTo('SelectQuarter');
            this.updatePageIndex();
        }
        hideContextMenu() {
            var _a;
            if ((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened) {
                this._contextMenu.hide();
            }
        }
        resetPreselectedYears() {
            this._preselectedStartYear = undefined;
            this._preselectedEndYear = undefined;
            this.setMappers();
        }
        updateSelectedQuarter(quarter) {
            this.updateValue(quarter);
            this.updateInput();
        }
        updateValue(quarter) {
            if (!quarter) {
                this.startQuarter = undefined;
                this.endQuarter = undefined;
                this.dispatchChange();
            }
            else if (this.startQuarter === undefined || this.endQuarter !== undefined) {
                this.startQuarter = quarter;
                this.endQuarter = undefined;
            }
            else {
                this.endQuarter = quarter;
                if (pairLessOrEqual(this.endQuarter, this.startQuarter)) {
                    [this.startQuarter, this.endQuarter] = [this.endQuarter, this.startQuarter];
                }
                this.hideContextMenu();
                this.resetPreselectedYears();
                this.dispatchChange();
            }
        }
        updateInput() {
            let inputValue = '';
            if (this.startQuarter) {
                inputValue = `${getDictionary().translate('sds.quarter')}${this.startQuarter[1]}  ${this.startQuarter[0]}`;
            }
            if (this.endQuarter) {
                inputValue += ` - ${getDictionary().translate('sds.quarter')}${this.endQuarter[1]}  ${this.endQuarter[0]}`;
            }
            this._inputDate.value = inputValue;
        }
        dispatchChange() {
            this.dispatchEvent(new CustomEvent(SdsQuarterRange.QUARTER_RANGE_CHANGE_EVENT, {
                detail: {
                    startQuarter: this.startQuarter
                        ? quarterDateToKey(...this.startQuarter)
                        : undefined,
                    endQuarter: this.endQuarter ? quarterDateToKey(...this.endQuarter) : undefined,
                },
            }));
        }
    };
    _SdsQuarterRange_placeholder_accessor_storage = new WeakMap();
    _SdsQuarterRange_hint_accessor_storage = new WeakMap();
    _SdsQuarterRange_disabled_accessor_storage = new WeakMap();
    _SdsQuarterRange_invalid_accessor_storage = new WeakMap();
    _SdsQuarterRange_errorMessage_accessor_storage = new WeakMap();
    _SdsQuarterRange_currentQuarter_accessor_storage = new WeakMap();
    _SdsQuarterRange_startQuarter_accessor_storage = new WeakMap();
    _SdsQuarterRange_endQuarter_accessor_storage = new WeakMap();
    _SdsQuarterRange__contextMenu_accessor_storage = new WeakMap();
    _SdsQuarterRange__inputDate_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsQuarterRange");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _placeholder_decorators = [property({ type: String })];
        _hint_decorators = [property({ type: String })];
        _disabled_decorators = [property({ type: Boolean })];
        _invalid_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        _currentQuarter_decorators = [property({ attribute: 'current-quarter' })];
        _startQuarter_decorators = [property({
                type: String,
                converter: quarterKeyToDate,
                attribute: 'start-quarter',
            })];
        _endQuarter_decorators = [property({
                type: String,
                converter: quarterKeyToDate,
                attribute: 'end-quarter',
            })];
        __contextMenu_decorators = [query('sds-context-menu')];
        __inputDate_decorators = [query('#input-date')];
        __esDecorate(_classThis, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
        __esDecorate(_classThis, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(_classThis, null, _currentQuarter_decorators, { kind: "accessor", name: "currentQuarter", static: false, private: false, access: { has: obj => "currentQuarter" in obj, get: obj => obj.currentQuarter, set: (obj, value) => { obj.currentQuarter = value; } }, metadata: _metadata }, _currentQuarter_initializers, _currentQuarter_extraInitializers);
        __esDecorate(_classThis, null, _startQuarter_decorators, { kind: "accessor", name: "startQuarter", static: false, private: false, access: { has: obj => "startQuarter" in obj, get: obj => obj.startQuarter, set: (obj, value) => { obj.startQuarter = value; } }, metadata: _metadata }, _startQuarter_initializers, _startQuarter_extraInitializers);
        __esDecorate(_classThis, null, _endQuarter_decorators, { kind: "accessor", name: "endQuarter", static: false, private: false, access: { has: obj => "endQuarter" in obj, get: obj => obj.endQuarter, set: (obj, value) => { obj.endQuarter = value; } }, metadata: _metadata }, _endQuarter_initializers, _endQuarter_extraInitializers);
        __esDecorate(_classThis, null, __contextMenu_decorators, { kind: "accessor", name: "_contextMenu", static: false, private: false, access: { has: obj => "_contextMenu" in obj, get: obj => obj._contextMenu, set: (obj, value) => { obj._contextMenu = value; } }, metadata: _metadata }, __contextMenu_initializers, __contextMenu_extraInitializers);
        __esDecorate(_classThis, null, __inputDate_decorators, { kind: "accessor", name: "_inputDate", static: false, private: false, access: { has: obj => "_inputDate" in obj, get: obj => obj._inputDate, set: (obj, value) => { obj._inputDate = value; } }, metadata: _metadata }, __inputDate_initializers, __inputDate_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsQuarterRange = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.QUARTER_RANGE_CHANGE_EVENT = 'sds.quarter-range.changed';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsQuarterRange = _classThis;
})();
export { SdsQuarterRange };
